import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    quantity: Number,
    typeId: Number,
    maxQuantity: Number,
    persisted: Boolean
  }

  static targets = ["display", "minusBtn", "plusBtn", "hiddenFields"]

  async update(event) {
    event.preventDefault()
    event.stopPropagation()

    const delta = parseInt(event.currentTarget.dataset.delta)
    const newQuantity = this.quantityValue + delta

    // Validiere Grenzen
    if (newQuantity < 0) return
    if (newQuantity > this.maxQuantityValue) return

    if (this.persistedValue) {
      // Persistierte Buchung: Server-Request
      await this.updateOnServer(newQuantity)
    } else {
      // Neue Buchung: Client-seitig aktualisieren
      this.updateLocally(newQuantity, delta)
    }
  }

  getCSRFToken() {
    // Versuche zuerst das Meta-Tag
    const metaTag = document.querySelector('meta[name="csrf-token"]')
    if (metaTag) {
      return metaTag.content
    }

    // Fallback: Versuche das Token aus einem Formular zu holen
    const form = document.querySelector('form')
    if (form) {
      const tokenInput = form.querySelector('input[name="authenticity_token"]')
      if (tokenInput) {
        return tokenInput.value
      }
    }

    // Letzter Fallback: Versuche es aus dem document head
    const headToken = document.head.querySelector('meta[name="csrf-token"]')
    if (headToken) {
      return headToken.content
    }

    console.warn('CSRF-Token nicht gefunden')
    return null
  }

  async updateOnServer(newQuantity) {
    try {
      const csrfToken = this.getCSRFToken()
      const headers = {
        'Accept': 'text/vnd.turbo-stream.html'
      }

      // Füge CSRF-Token nur hinzu, wenn es vorhanden ist
      // (CSRF-Schutz ist deaktiviert, aber Token kann trotzdem vorhanden sein)
      if (csrfToken) {
        headers['X-CSRF-Token'] = csrfToken
      }

      const response = await fetch(this.urlValue + `&quantity=${newQuantity}`, {
        method: 'PATCH',
        headers: headers
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        console.error('Server responded with error:', response.status, response.statusText)
      }
    } catch (error) {
      console.error('Error updating quantity:', error)
    }
  }

  updateLocally(newQuantity, delta) {
    // Update quantity value
    this.quantityValue = newQuantity

    // Update display
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = newQuantity
    }

    // Update hidden fields
    if (this.hasHiddenFieldsTarget) {
      if (delta > 0) {
        // Add hidden field
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'booking[type_ids][]'
        input.value = this.typeIdValue
        input.dataset.availabilityTarget = 'type'
        this.hiddenFieldsTarget.appendChild(input)
      } else if (delta < 0 && newQuantity >= 0) {
        // Remove one hidden field
        const inputs = this.hiddenFieldsTarget.querySelectorAll(`input[value="${this.typeIdValue}"]`)
        if (inputs.length > 0) {
          inputs[inputs.length - 1].remove()
        }
      }

      // Remove entire type row if quantity is 0
      if (newQuantity === 0) {
        this.element.closest('.booking-type-row')?.remove()
      }
    }

    // Update button states
    this.updateButtonStates(newQuantity)
  }

  updateButtonStates(quantity) {
    if (this.hasMinusBtnTarget) {
      this.minusBtnTarget.disabled = quantity <= 0
    }
    if (this.hasPlusBtnTarget) {
      this.plusBtnTarget.disabled = quantity >= this.maxQuantityValue
    }
  }
}

